import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import Modal from 'react-bootstrap/Modal';
import SelectTable from '../select-table'
import ApiClient from "../../services/api-client"
import { useTranslation } from 'react-i18next';
import loadCompaniesOptions from "../../services/loaddata/loadCompanies";
import useStore from '../../hooks/useStore';
import Logo from '../../img/timologic.png';

const loadPageOptions = async (q, prevOptions, { page }, props) => {
    const { options, hasMore } = await loadCompaniesOptions(q, page, props);
    return { options, hasMore, additional: { page: page + 1 } };
};

const ChooseCompany = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [selectedCompany, setSelectedCompany] = useState();
    const [showCompanyModal, setShowCompanyModal] = useState(false);

    useImperativeHandle(ref, () => ({
        open() { setShowCompanyModal(true); },
        close() { setShowCompanyModal(false); },
    }));

    const handleChange = value => {
        setSelectedCompany(value);
        localStorage.removeItem("defaults");
        ApiClient.getCompany(value.value).then(
            response => localStorage.setItem("company", JSON.stringify(response.data)),
            error => console.error(error.message || error.toString())
        );
    };

    useEffect(() => {
        const jsonComp = useStore.getState().selectedCompany;
        if (jsonComp) {
            setSelectedCompany({ value: jsonComp.id, label: jsonComp.name, taxid: jsonComp.taxpayerId });
        } else {
            setSelectedCompany(null);
            setShowCompanyModal(true);
        }
    }, []);

    return (
        <Modal
            aria-labelledby="choose-company-title"
            centered
            show={showCompanyModal}
            dialogClassName="company-modal-dialog"
            onHide={props.handleCloseCompanyModal}
            backdrop="static"
            className="company-modal"
            keyboard={false}
        >
            {/* ── Branded header ── */}
            <div className="company-modal-header">
                <div className="company-modal-header-pattern" />
                <div className="company-modal-header-content">
                    <img src={Logo} alt="Timologic" className="company-modal-logo" />
                    <div className="company-modal-header-text">
                        <h5 className="company-modal-title" id="choose-company-title">
                            {t("chooseCompany")}
                        </h5>
                        <p className="company-modal-subtitle">
                            {selectedCompany ? selectedCompany.label : t("Select")}
                        </p>
                    </div>
                </div>
            </div>

            {/* ── Select zone ── */}
            <Modal.Body className="company-modal-body">
                <label className="company-modal-label">
                    <i className="fa fa-search company-modal-search-icon"></i>
                    {t("chooseCompany")}
                </label>
                <SelectTable
                    inputId="choose-company-select"
                    classNamePrefix="co-sel"
                    defaultValue={selectedCompany}
                    onChangeValue={handleChange}
                    columns={[
                        { header: t("Name"), field: "name", flex: 8, asLabel: true },
                        { header: t("taxpayerId"), field: "taxpayerId", flex: 4 }
                    ]}
                    value={selectedCompany}
                    asyncPaginate={true}
                    key={new Date().getTime()}
                    placeholder={t('Select')}
                    loadOptions={loadPageOptions}
                    menuPortalTarget={document.body}
                />
            </Modal.Body>

            {/* ── Footer ── */}
            <Modal.Footer className="company-modal-footer">
                <button className="btn btn-skin company-modal-btn" onClick={props.handleCloseCompanyModal}>
                    {t("Choose")}
                    <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                </button>
            </Modal.Footer>
        </Modal>
    );
});

export default ChooseCompany;
